import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=f69ece84"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f69ece84')) {
      api.createRecord('f69ece84', component.options)
    } else {
      api.reload('f69ece84', component.options)
    }
    module.hot.accept("./Clients.vue?vue&type=template&id=f69ece84", function () {
      api.rerender('f69ece84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Clients.vue"
export default component.exports